import React from 'react';

interface GalleryGridProps {
  items: any[];
  renderItem: (item: any) => React.ReactNode;
}

export const GalleryGrid: React.FC<GalleryGridProps> = ({
  items,
  renderItem,
}) => {
  return (
    <section className="py-16 px-6 md:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {items.map((item) => (
            <div key={item.id}>{renderItem(item)}</div>
          ))}
        </div>
      </div>
    </section>
  );
};
